import { IBlock } from "framework/src/IBlock";
import { Message } from "framework/src/Message";
import { BlockComponent } from "framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "framework/src/Messages/MessageEnum";
import { runEngine } from "framework/src/RunEngine";
// Customizable Area Start
import { makeApiMessage } from "../../../components/src/common";
import { BusinessAccountCustomer } from "./utils";
// Customizable Area End

// Customizable Area Start
export const configJSON = require("./config");

const initialBusinessAccountCustomer = {
  type: "business_account_customer",
  id: 0,
  attributes: {
    activated: false,
    id: 0,
    full_phone_number: "",
    name: "",
    department_name: "",
    email: "",
    cost_center: "",
    department_id: "",
    address: "",
    sub_cost_center: "",
    notes: "",
    postal_code: "",
    no_of_order: 0,
    private_notes: "",
    business_account_id: 0,
    no_of_pieces: 0,
    sub_company_name: null,
    employee_id: "",
    used_no_of_pieces: null,
    used_no_of_orders: null,
      company: {
        name: "",
          id: 0,
        },
      business_account: {
        business_customer: "",
        id: 0,
      },
      business_customer_group: {
        group_name: "",
        id: 0,
      },
      price_list: {
        name: "",
          id: 0,
      },
      city: null,
      gender: {
        label: "",
          id: 0,
      },
      full_name: "",
      country_code: "",
      phone_number: "",
      contract_no_of_order: null,
      contract_no_of_pieces: null,
  },
};

// Customizable Area End

export interface Props {
  // Customizable Area Start
  navigation: any;
  id: string;
  customerId: string;
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  isDataLoading: boolean;
  customerData: BusinessAccountCustomer;
  // Customizable Area End
}

interface SS {
  // Customizable Area Start
  // Customizable Area End
}

export default class B2BCustomerShowModalStatusTabController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  getCustomerViewDetailsCallId: string = ""
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionResponseMessage),
    ];
    // Customizable Area End

    // Customizable Area Start
    // Customizable Area End

    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    this.state = {
      customerData: initialBusinessAccountCustomer,
      isDataLoading: false,
    };
    // Customizable Area End
  }

  async componentDidMount() {
    super.componentDidMount();
    // Customizable Area Start
    this.getCustomerViewData();
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    if (message.id === getName(MessageEnum.RestAPIResponceMessage)) {
      let apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      let responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      if(apiRequestCallId === this.getCustomerViewDetailsCallId) {
        this.handleGetCustomerResponse(responseJson);
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  handleGetCustomerResponse = (response: {
    data: BusinessAccountCustomer;
  }) => {
    if(response && response.data) {
      this.setState({ customerData: response.data });
    }
    this.setState({ isDataLoading: false });
  };
  
  getCustomerViewData = () => {
    this.setState({ isDataLoading: true });

    const { customerId } = this.props;

    const ApiUrl = configJSON.B2BCustomerAPIEndpoint;
 
    let requestMessage = makeApiMessage({
      url: ApiUrl + "/" + customerId,
      method: "GET",
    });
    this.getCustomerViewDetailsCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };


  // Customizable Area End
}
